import styled, { css } from 'styled-components';

import { rem } from '../../utils';

export const StyledListWrapper = styled.section`
  display: flex;
  flex-flow: column;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  margin: ${({ theme }) => `${rem(theme.Spacing.Size.Small)} 0`};
`;

export const StyledWrapper = styled.article<{ isOpened: boolean }>`
  display: flex;
  width: 100%;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  ${({ theme, isOpened }) =>
    isOpened &&
    `
    background: ${theme.Color.Neutrals.Light};
  `}

  &:hover {
    background: ${({ theme }) => theme.Components.Panel.BackgroundHover};
    transition: all ${({ theme }) => theme.Transition.Timing.In};
  }
`;

export const StyledIconWrapper = styled.div<{ hasIconWrapper?: boolean }>`
  display: inline-flex;
  ${({ theme, hasIconWrapper }) =>
    !hasIconWrapper
      ? css`
          background-color: ${theme.Color.Neutrals.Paper};
          border-radius: ${rem(theme.Border.Radius.Medium)};
          padding: ${rem(theme.Spacing.Size.Small)};
          outline: ${`${rem(theme.Border.Size.Small)} ${theme.Color.Neutrals.Border} solid`};
        `
      : css`
          background-color: 'transparent';
          padding: 0;
          outline: 'none';
        `};

  outline-offset: -1px;
  position: relative;
`;

export const StyledIcon = styled.div<{ hasIconWrapper?: boolean }>`
  ${({ hasIconWrapper }) =>
    hasIconWrapper
      ? css`
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        `
      : css`
          display: inline-flex;
        `}
`;

export const StyledLabel = styled.div<{ isOpened: boolean }>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  cursor: pointer;
  user-select: none;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  padding: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;

export const StyledTextWrapper = styled.div<{
  hasSubTitle: boolean;
}>`
  display: flex;
  flex-flow: column;
  width: 100%;
  max-width: 160px;
  height: 40px;
  justify-content: ${({ hasSubTitle }) => (hasSubTitle ? 'space-between' : 'center')};
`;

export const StyledChevronWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`;
export const StyledContentWrapper = styled.div`
  display: flex;
  width: 100%;

  & > div {
    width: 100%;
  }
`;
export const StyledContent = styled.div`
  width: 100%;
  padding: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;

export const StyledIconFolder = styled.div`
  width: 100%;
  min-width: ${rem(67)};
  i {
    svg {
      width: ${rem(67)};
      height: ${rem(50)};
    }
  }
`;
